/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useStyles from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "components/header";
import Footer from "components/footerUser";
import {
  Box,
  Flex,
  Text,
  useBreakpointValue,
  Grid,
  Divider,
  Button,
} from "@chakra-ui/react";
import Gambar1 from "../../assets/img/Home1.webp";
import Gambar2 from "../../assets/img/Home2.webp";
import Gambar3 from "../../assets/img/Home3.webp";
import Gambar4 from "../../assets/img/Home4.webp";
import ProfilingComplete from "../../assets/img/ProfilingComplete.webp";
import ProfilingStandard from "../../assets/img/ProfilingStandard.webp";
import ProfilingPilihanCareerTerbaik from "../../assets/img/ProfilingPilihanCareerTerbaik.webp";
import ProfilingSifatdanSikapDitempatKerja from "../../assets/img/ProfilingSifatdanSikapDitempatKerja.webp";
import ProfilingHubunganCintadanSosial from "../../assets/img/ProfilingHubunganCintadanSosial.webp";
import MatchingFriendship from "../../assets/img/MatchingFriendship.webp";
import MatchingPartnership from "../../assets/img/MatchingPartnership.webp";
import MatchingRomance from "../../assets/img/MatchingRomance.webp";
import PersonaGeneral from "../../assets/img/PersonaGeneral.webp";
import PersonaDaily from "../../assets/img/PersonaDaily.webp";
import PartnershipMobile from "../../assets/img/PartnershipMobile.jpg";
import RomanceMobile from "../../assets/img/RomanceMobile.jpg";
import FriendshipMobile from "../../assets/img/FriendshipMobile.jpg";
import axios from "axios";

const Home = () => {
  const styles = useStyles();
  const [user, setUser] = useState();

  useEffect(() => {
    // console.log(theme.breakpoints.values.md)
    const token = localStorage.getItem("token");
    let currentUser = localStorage.getItem("user");
    if (token) {
      axios
        .get(`https://api.personatalenta.id/user/current`, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
          },
        })
        .then((res) => {
          if (res?.data) {
            setUser(res?.data?.user);
          }
        })
        .catch((err) => {
          if (
            err.response.data.message === "Unauthorized" ||
            err.response.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
    if (currentUser) {
      currentUser = JSON.parse(currentUser);
      setUser(currentUser);
    }
  }, []);

  const MobileServiceCard = ({ img, title, desc, onClick, bg }) => (
    <Box
      bg={bg}
      borderRadius="lg"
      overflow="hidden"
      boxShadow="sm"
      cursor="pointer"
      onClick={onClick}
      border="1px solid"
      borderColor="gray.200"
    >
      <Flex h="100%">
        <Box
          width="100px"
          minWidth="100px"
          p={2}
          display="flex"
          alignItems="center"
        >
          <img
            src={img}
            alt={title}
            style={{ width: "100%", borderRadius: "4px", objectFit: "contain" }}
          />
        </Box>
        <Box
          p={3}
          flex="1"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            <Text fontWeight="bold" fontSize="md" mb={1} lineHeight="1.2">
              {title}
            </Text>
            <Text
              fontSize="xs"
              mb={2}
              color="gray.800"
              lineHeight="1.4"
              noOfLines={4}
            >
              {desc}
            </Text>
          </Box>
          <Text
            fontSize="xs"
            color="blue.500"
            textAlign="right"
            fontStyle="italic"
            mt="auto"
          >
            Selanjutnya ...
          </Text>
        </Box>
      </Flex>
    </Box>
  );

  return (
    <div className={styles.app}>
      <Header active="home" />
      <div className={styles.heroContainer}>
        {/* Desktop Hero */}
        <div className={styles.hero}>
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            loop
            modules={[Pagination, Autoplay]}
          >
            <SwiperSlide>
              <Flex flexDirection={{ sm: "column", lg: "row" }} gap={5}>
                <img
                  src={Gambar1}
                  alt="career profiling"
                  className={styles.img}
                />
                <Flex flexDirection="column">
                  <span className="title">
                    Apakah Kamu Sedang Mencari Kerja? Atau Merasa kurang cocok
                    dengan KARIR KAMU SAAT INI….?
                  </span>
                  <p className="content">
                    Temukan jalan karir terbaikmu dengan memahami kepribadianmu
                    ! Cocokkan passion dengan profesi ideal, dan capai
                    kesuksesan dengan cara yang lebih cerdas.
                  </p>
                  <p className="content">
                    PROFILING Persona Talenta dapat membantu kamu menemukan
                    PILIHAN KARIR TERBAIK BUAT KAMU.
                  </p>
                </Flex>
              </Flex>
            </SwiperSlide>

            <SwiperSlide>
              <Flex flexDirection={{ sm: "column", lg: "row" }} gap={5}>
                <img
                  src={Gambar2}
                  alt="workstyle profiling"
                  className={styles.img}
                />
                <Flex flexDirection="column">
                  <span className="title">
                    Kenapa aku nggak cocok kerja bareng Dia! Apakah WORKSTYLE ku
                    terlalu berbeda jauh ya?
                  </span>
                  <p className="content">
                    Kenali karakter kerja kamu dan temanmu Kamu akan memegang
                    kendali, lihai menghadapi berbagai gaya kerja teman-temanmu
                  </p>
                  <p className="content">
                    PROFILING Persona Talenta membantumu menemukan KARAKTER
                    KERJA DAN GAYA KERJA teman-temanmu
                  </p>
                </Flex>
              </Flex>
            </SwiperSlide>
            <SwiperSlide>
              <Flex flexDirection={{ sm: "column", lg: "row" }} gap={5}>
                <img
                  src={Gambar3}
                  alt="relationship profiling"
                  className={styles.img}
                />
                <Flex flexDirection="column">
                  <span className="title">
                    Hubungan CINTA, SOSIAL DAN KELUARGA kok sulit harmoni ya!
                    Bagaiman caranya untuk dealing dan interaksi?
                  </span>
                  <p className="content">
                    Pernahkan kamu mengalami kesulitan untuk membangun hubungan
                    dengan pasangan, teman bahkan keluarga mu !
                  </p>
                  <p className="content">
                    PROFILING Persona Talenta membantu kamu menemukan
                    KEPRIBADIAN DALAM MEMBANGUN HUBUNGAN Dan Cara-cara Dealing
                    dan Interaksimu.
                  </p>
                </Flex>
              </Flex>
            </SwiperSlide>
            <SwiperSlide>
              <Flex flexDirection={{ sm: "column", lg: "row" }} gap={5}>
                <img src={Gambar4} alt="matching" className={styles.img} />
                <Flex flexDirection="column">
                  <span className="title">
                    Pernahkah kamu bertanya, seberapa besar KECOCOKANMU DENGAN
                    PASANGAN, SAHABAT, ATAU REKAN KERJAMU?
                  </span>
                  <p className="content">
                    Temukan jawabannya sekarang dan perkuat hubunganmu dengan
                    insight yang tepat!
                  </p>
                  <p className="content">
                    MATCHING Persona Talenta membantu kamu berapa % persen
                    kompatibilitas kamu dengan pasangan, sahabat, rekan yang
                    bisa kamu pilih, tentukan sendiri !
                  </p>
                </Flex>
              </Flex>
            </SwiperSlide>
          </Swiper>
          {!user && (
            <div
              style={{ position: "absolute", right: 20, bottom: 20, zIndex: 1 }}
            >
              <a href="/login">
                <div
                  style={{
                    backgroundColor: "#9A1F16",
                    borderRadius: 10,
                    border: 3,
                    borderStyle: "solid",
                    borderColor: "#FFFF54",
                    padding: "5px 20px",
                  }}
                >
                  <Text color="#fff">DAFTAR GRATIS</Text>
                </div>
              </a>
            </div>
          )}
        </div>

        {/* Mobile Hero */}
        <Box
          display={{ base: "block", lg: "none" }}
          width="100%"
          // px={5}
          pt={3}
          mb={0}
        >
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            loop
            modules={[Pagination, Autoplay]}
            style={{ paddingBottom: "30px" }}
          >
            <SwiperSlide>
              <Box
                bg="#0045B0"
                // height="200px"
                borderRadius="2xl"
                p={6}
                color="white"
                boxShadow="lg"
                // mx={5}
              >
                <Text fontSize="lg" fontWeight="bold" lineHeight="1.2">
                  Selamat datang di Persona Talenta
                </Text>
                <Text fontSize="xs">
                  Disini kamu bisa mengenal diri kamu, teman dan pasangan.
                </Text>
                <Flex
                  flexDirection="column"
                  fontSize="xs"
                  lineHeight="1.2"
                  gap={1}
                  mt={"10px"}
                >
                  <Text>
                    <Text as="span" fontWeight="bold">
                      PROFILING
                    </Text>{" "}
                    didesain sangat personal dan berbeda antara satu orang
                    dengan yang lain.
                  </Text>
                  <Text>
                    <Text as="span" fontWeight="bold">
                      MATCHING
                    </Text>{" "}
                    dihitung secara detail dan mendalam.
                  </Text>
                  <Text>
                    <Text as="span" fontWeight="bold">
                      PERSONA
                    </Text>{" "}
                    disusun sistematis dan jelas di Persona Talenta ini!
                  </Text>
                </Flex>
              </Box>
            </SwiperSlide>
          </Swiper>
        </Box>
      </div>
      <div className={styles.bottomContainer}>
        <Flex
          maxWidth={1080}
          width="100%"
          direction="column"
          gap={8}
          paddingX={{ sm: "20px", md: 0 }}
        >
          <Box width="100%">
            {/* Desktop Header */}
            <Text
              as="h1"
              fontWeight="bold"
              fontSize="lg"
              mb={3}
              display={{ base: "none", lg: "block" }}
            >
              PROFILING SERVICE
            </Text>
            {/* Mobile Header */}
            <Box display={{ base: "block", lg: "none" }} mb={4}>
              <Flex justifyContent="space-between" alignItems="center" mb={1}>
                <Text
                  as="h1"
                  fontWeight="bold"
                  fontSize="xl"
                  textTransform="uppercase"
                >
                  PROFILING
                </Text>
                {!user && (
                  <Button
                    size="sm"
                    bgColor="#059212"
                    color="white"
                    fontSize="xs"
                    px={3}
                    py={1}
                    borderRadius="5px"
                    onClick={() => window.location.assign("/login")}
                    _hover={{ bg: "#047a0f" }}
                  >
                    Daftar Gratis
                  </Button>
                )}
              </Flex>
              <Divider
                orientation="horizontal"
                borderColor="black"
                borderBottomWidth="2px"
              />
              <Text
                fontSize="xs"
                mt={2}
                color="black"
                textAlign="left"
                lineHeight="1.5"
              >
                Hasil profiling yang dibuat Persona Talenta adalah sangat
                spesifik, sesuai dengan masing-masing pribadi, dengan
                menggunakan metoda analitik bazi, astrologi dan algoritma yang
                sesuai, menjadikan Profiling kami sangat personal, mudah dibaca
                dan digunakan. Hasil profiling kami kemas kedalam satu file pdf
                buku pribadi.
              </Text>
            </Box>

            <Flex
              direction="row"
              mt={5}
              overflowX="hidden"
              width="100%"
              display={{ base: "none", lg: "flex" }}
            >
              <Flex container gap={5} width="100%" flexWrap="wrap">
                <Flex direction="column" width={{ sm: "100%", md: 250 }}>
                  <img
                    src={ProfilingPilihanCareerTerbaik}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#016A70"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text color="#fff" fontWeight="bold" textAlign="center">
                      PILIHAN KARIR TERBAIK
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/profiling#0")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#059212"
                    h={{ sm: 200, md: 280 }}
                  >
                    <Text color="#fff">
                      Mengetahui karir yang sesuai dengan bakat memiliki banyak
                      manfaat, baik dari segi profesional maupun personal.
                      Berikut beberapa manfaat utamanya
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#fff"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex direction="column" width={{ sm: "100%", md: 250 }}>
                  <img
                    src={ProfilingSifatdanSikapDitempatKerja}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#016A70"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text color="#fff" fontWeight="bold" textAlign="center">
                      PERSONAL WORKSTYLE
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/profiling#1")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#059212"
                    h={{ sm: 200, md: 280 }}
                  >
                    <Text color="#fff">
                      Memahami Workstyle (gaya kerja) diri sendiri dan rekan
                      kerja memberikan banyak manfaat dalam sebuah kerja sama.
                      Berikut beberapa manfaat utamanya.
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#fff"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex direction="column" width={{ sm: "100%", md: 250 }}>
                  <img
                    src={ProfilingHubunganCintadanSosial}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#016A70"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      RELATIONSHIP CHARACTER
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/profiling#2")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#059212"
                    h={{ sm: 200, md: 280 }}
                  >
                    <Text color="#fff">
                      Memahami karakter pasangan dalam menjalin relasi sosial
                      dan cinta memberikan banyak manfaat yang sangat penting
                      untuk menjaga hubungan yang sehat, bahagia, dan bertahan
                      lama. Berikut beberapa manfaat utamanya
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#fff"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex direction="column" width={{ sm: "100%", md: 250 }}>
                  <img
                    src={ProfilingStandard}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#016A70"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      POTENTIAL TALENT
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/profiling#3")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#059212"
                    h={{ sm: 200, md: 280 }}
                  >
                    <Text color="#fff">
                      Manfaat Kuliah Sesuai Dengan Talent 1. Meningkatkan
                      Motivasi dan Semangat Belajar: Ketika kamu belajar di
                      bidang yang sesuai dengan bakatmu, proses belajar menjadi
                      lebih menyenangkan dan tidak terasa sebagai beban.
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#fff"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex direction="column" width={{ sm: "100%", md: 250 }}>
                  <img
                    src={ProfilingComplete}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#016A70"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      COMPLETE PROFILING
                    </Text>
                    <Text textAlign="center" color="white" fontSize="xs">
                      Bundling: Career, Workstyle, Relationship
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/profiling#4")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#059212"
                    h={{ sm: 200, md: 280 }}
                  >
                    <Text color="#fff">
                      Mengetahui profil komplit dengan memahmi karir yang cocok,
                      gaya kerja yang pas, dan memahami relasi hubungan secara
                      komplit memberikan manfaat yang besar dan menyeluruh dalam
                      hidup
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#fff"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>

            {/* Mobile Content Profiling */}
            <Flex
              display={{ base: "flex", lg: "none" }}
              direction="column"
              gap={4}
            >
              <MobileServiceCard
                bg="#E0F7FA"
                img={ProfilingPilihanCareerTerbaik}
                title="Pilihan Karir Terbaik"
                desc="Karir sesuai bakat. Tips meningkatkan peran dikarir, memperluas wawasan, ketajaman bisnis. Cara meningkatkan ketajaman bisnis, manajemen keuangan, profesionalitas kerja. Cara pengembangan potensi diri dan langkah terbaik untuk sukses."
                onClick={() => window.location.assign("/profiling#0")}
              />
              <MobileServiceCard
                bg="#E0F2F1"
                img={ProfilingSifatdanSikapDitempatKerja}
                title="Gaya Kerja Personal"
                desc="Profesionalitas, karakter kerja, model kepemimpinanmu. Tips memimpin lebih baik, cara dealing, tahu karakter tersembunyi, sifat dominan, kekuatan dan kelemahan. Cara mengembangkan potensi ditempat kerja."
                onClick={() => window.location.assign("/profiling#1")}
              />
              <MobileServiceCard
                bg="#E8F5E9"
                img={ProfilingHubunganCintadanSosial}
                title="Karakter Dalam Manjalin Hubungan"
                desc="Kepribadian dalam interaksi sosial dan intim. Jalinan persahabatan, romansa dan kemitraan. Tips persahabatan, kemitraan, kehidupan cinta dan seksualitas. Potret hubungan keluarga, perilaku sebagai orang tua, memahami perilaku dan cara mengatasinya."
                onClick={() => window.location.assign("/profiling#2")}
              />
              <MobileServiceCard
                bg="#E3F2FD"
                img={ProfilingStandard}
                title="Potensi Akademik"
                desc="Jurusan studi/bidang studi sesuai potensi. Personalitas, attitude dan etos kerja, strategi menghadapi dealing, tips dan ide, tips berpikir. Pengembangan potensi, kiat menggali potensi, jalan kesuksesan."
                onClick={() => window.location.assign("/profiling#3")}
              />
              <MobileServiceCard
                bg="#E0F7FA"
                img={ProfilingComplete}
                title="Complete Profiling Karir Terbaik, Gaya Kerja dan Karakter Hubungan"
                desc="Kami sajikan hasil Profiling Pilihan Karir Terbaik, Gaya Kerja Personal dan Karakter dalam menjalin hubungan dalam satu buku lengkap. Hasil ini merupakan satu kesatuan profiling yang komprehensif ini"
                onClick={() => window.location.assign("/profiling#4")}
              />
            </Flex>
          </Box>
          <Box width="100%">
            <Text
              as="h1"
              fontWeight="bold"
              fontSize="lg"
              mb={3}
              display={{ base: "none", lg: "block" }}
            >
              MATCHING SERVICE
            </Text>
            {/* Mobile Header Matching */}
            <Box display={{ base: "block", lg: "none" }} mb={4}>
              <Text
                as="h1"
                fontWeight="bold"
                fontSize="xl"
                mb={1}
                textTransform="uppercase"
              >
                MATCHING
              </Text>
              <Divider
                orientation="horizontal"
                borderColor="black"
                borderBottomWidth="2px"
              />
              <Text
                fontSize="xs"
                mt={2}
                color="black"
                textAlign="left"
                lineHeight="1.5"
              >
                Layanan Matching kami, hadir untuk membantu Anda menemukan
                orang-orang yang benar-benar sejalan, baik sebagai partner
                kolaborasi, pasangan hidup, maupun sahabat. Kami percaya bahwa
                hubungan yang bermakna lahir dari keselarasan nilai, rasa saling
                memahami dan tujuan yang tumbuh bersama. Melalui proses dan
                algoritma kami mempertemukan Anda dengan koneksi yang bukan
                hanya cocok, tetapi juga terasa nyaman dan berarti dalam
                perjalanan hidup Anda.
              </Text>
            </Box>

            <Flex
              direction="row"
              mt={5}
              overflowX="hidden"
              width="100%"
              display={{ base: "none", lg: "flex" }}
            >
              <Flex container gap={5} width="100%" flexWrap="wrap">
                <Flex
                  direction="column"
                  width={{ sm: "100%", md: 250 }}
                  maxWidth={{ sm: "100%", md: 250 }}
                >
                  <img
                    src={MatchingPartnership}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#7A611D"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      PARTNERSHIP MATCHING
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() =>
                      window.location.assign("/matching#partnership")
                    }
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#FBE7A3"
                    h={{ sm: 220, md: 260 }}
                  >
                    <Text color="#000">
                      Mengetahui ukuran kecocokan dalam partnership - baik itu
                      dalam bisnis, pekerjaan, maupun proyek kolaboratif -
                      memberikan banyak keuntungan yang dapat memengaruhi
                      efektivitas, produktivitas, dan kepuasan kerja.
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#000"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  direction="column"
                  width={{ sm: "100%", md: 250 }}
                  maxWidth={{ sm: "100%", md: 250 }}
                >
                  <img
                    src={MatchingRomance}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#A225B5"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      ROMANCE MATCHING
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/matching#romance")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#F7D0FC"
                    h={{ sm: 220, md: 260 }}
                  >
                    <Text color="#000">
                      Manfaat kecocokan dalam hubungan cinta antar pasangan. Ini
                      topik yang penting banget, karena kecocokan itu bisa jadi
                      fondasi utama buat hubungan yang langgeng dan sehat
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#000"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  direction="column"
                  width={{ sm: "100%", md: 250 }}
                  maxWidth={{ sm: "100%", md: 250 }}
                >
                  <img
                    src={MatchingFriendship}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#3E8C88"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      FRIENDSHIP MATCHING
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() =>
                      window.location.assign("/matching#friendship")
                    }
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#54B9B6"
                    h={{ sm: 220, md: 260 }}
                  >
                    <Text color="#000">
                      Kecocokan dalam persahabatan punya manfaat besar yang
                      kadang underrated. Persahabatan yang cocok bisa jadi
                      sumber energi positif, tempat healing, dan bahkan jadi
                      fondasi support system yang kuat
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#000"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>

            {/* Mobile Content Matching */}
            <Flex
              display={{ base: "flex", lg: "none" }}
              direction="column"
              gap={4}
            >
              <MobileServiceCard
                bg="#F9FBE7"
                img={PartnershipMobile}
                title="Partnership"
                desc="Mengetahui ukuran kecocokan partnership bisnis, pekerjaan. Akan memberikan banyak keuntungan, efektivitas, produktivitas, dan kepuasan kerja."
                onClick={() => window.location.assign("/matching#partnership")}
              />
              <MobileServiceCard
                bg="#F3E5F5"
                img={RomanceMobile}
                title="Romance"
                desc="Tahu besaran kecocokan hubungan cinta dengan pasangan, bisa jadi fondasi utama untuk hubungan yang langgeng dan sehat."
                onClick={() => window.location.assign("/matching#romance")}
              />
              <MobileServiceCard
                bg="#E0F2F1"
                img={FriendshipMobile}
                title="Friendship"
                desc="Persahabatan punya manfaat besar, yang kadang underrated. Nilai kecocokan bisa jadi sumber energi positif, tempat healing, dan bahkan jadi fondasi support system yang kuat."
                onClick={() => window.location.assign("/matching#friendship")}
              />
            </Flex>
          </Box>
          <Box width="100%">
            <Text
              as="h1"
              fontWeight="bold"
              fontSize="lg"
              mb={3}
              display={{ base: "none", lg: "block" }}
            >
              PERSONA SERVICE
            </Text>
            {/* Mobile Header Persona */}
            <Box display={{ base: "block", lg: "none" }} mb={4}>
              <Text
                as="h1"
                fontWeight="bold"
                fontSize="xl"
                mb={1}
                textTransform="uppercase"
              >
                PERSONA
              </Text>
              <Divider
                orientation="horizontal"
                borderColor="black"
                borderBottomWidth="2px"
              />
              <Text
                fontSize="xs"
                mt={2}
                color="black"
                textAlign="left"
                lineHeight="1.5"
              >
                Layanan Persona membantu Anda mengenali dan memahami diri secara
                lebih jujur dan mendalam, tentang siapa Anda, apa yang Anda
                butuhkan, dan bagaimana Anda ingin hadir dalam setiap hubungan
                dan peran. Melalui proses yang penuh empati, layanan ini
                menuntun Anda menemukan kekuatan, nilai, dan arah personal yang
                sering kali tersembunyi, sehingga Anda dapat melangkah dengan
                lebih percaya diri, autentik, dan selaras dengan diri sendiri.
              </Text>
            </Box>

            <Flex
              direction="row"
              mt={5}
              overflowX="hidden"
              width="100%"
              display={{ base: "none", lg: "flex" }}
            >
              <Flex container gap={5} width="100%" flexWrap="wrap">
                <Flex
                  direction="column"
                  minWidth={{ sm: "100%", md: 250 }}
                  maxWidth={{ sm: "100%", md: 250 }}
                >
                  <img
                    src={PersonaGeneral}
                    alt="profile"
                    className={styles.img}
                  />
                  <Flex
                    backgroundColor="#253761"
                    borderTopRadius={10}
                    mb={2}
                    p={2}
                    h={70}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      as="h1"
                      color="#fff"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      PERSONA
                    </Text>
                  </Flex>
                  <Flex
                    position="relative"
                    flexDirection="column"
                    cursor="pointer"
                    onClick={() => window.location.assign("/persona")}
                    borderBottomRadius={10}
                    py={2}
                    px={3}
                    backgroundColor="#DCE3F1"
                    h={{ sm: 210, md: 250 }}
                  >
                    <Text fontWeight="bold">General dan Daily persona:</Text>
                    <Text color="#000">
                      Mengenali persona diri sendiri maupun orang lain punya
                      banyak manfaat, baik dalam kehidupan pribadi maupun
                      profesional
                    </Text>
                    <Text
                      position="absolute"
                      bottom={5}
                      right={6}
                      color="#000"
                      textAlign="end"
                    >
                      ...Read more
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>

            {/* Mobile Content Persona */}
            <Flex
              display={{ base: "flex", lg: "none" }}
              direction="column"
              gap={4}
            >
              <MobileServiceCard
                bg="#FFF3E0"
                img={PersonaGeneral}
                title="Persona"
                desc="Mengenal persona diri sendiri maupun orang lain punya banyak manfaat, baik dalam kehidupan pribadi maupun profesional."
                onClick={() => window.location.assign("/persona")}
              />
            </Flex>
          </Box>
        </Flex>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
